import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerEmpresas() {
    var url = ConfigAPI.baseURL + "accounting-business" + Session.getToken();
    return instance.get(url);
  },
  obtenerCajas() {
    var url = ConfigAPI.baseURL + "finances-cash" + Session.getToken();
    return instance.get(url);
  },
  mostrarCaja(id) {
    var url = ConfigAPI.baseURL + "finances-cash/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarCaja(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "finances-cash" + Session.getToken();
    return instance.post(url,params);
  },
  editarCaja(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarCaja(id) {
    var url = ConfigAPI.baseURL + "finances-cash/"+ id + Session.getToken();
    return instance.delete(url);
  },
  abrirCaja(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash/operation/open" + Session.getToken();
    return instance.post(url,params);    
  },
  cerrarCaja(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash/operation/close" + Session.getToken();
    return instance.post(url,params);    
  },
  reAbrirCaja(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash/operation/reopen" + Session.getToken();
    return instance.post(url,params);    
  },    
  
  agregarCajaDetalle(data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cash-detail" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerTiposMovimientoBancario() {
    var url = ConfigAPI.baseURL + "finances-bank-movement-types" + Session.getToken();
    return instance.get(url);
  },
  definirTipoMovimiento(id, bankType) {
    var url = ConfigAPI.baseURL + "finances-cash-detail/" + id + "/bank-type" + Session.getToken();
    return instance.post(url, { bank_type: bankType });
  },
  validarMovimientosParaComprobante(ids) {
    var url = ConfigAPI.baseURL + "finances-bank-movements/purchase-data" + Session.getToken();
    return instance.post(url, { ids: ids.join(',') });
  },
  eliminarCajaDetalle(id) {
    var url = ConfigAPI.baseURL + "finances-cash-detail/"+ id + Session.getToken();
    return instance.delete(url);
  },
  filtrarCajaDetalle(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash-detail/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },

  obtenerCheques() {
    var url = ConfigAPI.baseURL + "finances-cheques" + Session.getToken();
    return instance.get(url);
  },
  mostrarCheque(id) {
    var url = ConfigAPI.baseURL + "finances-cheques/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarCheque(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques" + Session.getToken();
    return instance.post(url,params);
  },
  editarCheque(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cheques/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarCheque(id) {
    var url = ConfigAPI.baseURL + "finances-cheques/"+ id + Session.getToken();
    return instance.delete(url);
  },
  filtrarCheques(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cheques/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },
  sumarChequesDisponibles() {
    var params = null    
    var url = ConfigAPI.baseURL + "finances-cheques/available/sum" + Session.getToken();
    return instance.post(url,params);
  },  

  rechazarCheque(id, data) {
    var url = ConfigAPI.baseURL + "finances-cheques/" + id + "/reject" + Session.getToken();
    return instance.post(url, data);
  },
  volverACarteraRechazo(id, data) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/return" + Session.getToken();
    return instance.post(url, data);
  },
  anularRechazo(id) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/cancel" + Session.getToken();
    return instance.post(url, null);
  },
  notasDebitoRechazo(id) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/debit-notes" + Session.getToken();
    return instance.get(url);
  },
  vincularNotaDebitoRechazo(id, salesId) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/link-sale" + Session.getToken();
    return instance.post(url, { sales_id: salesId });
  },
  resolverRechazo(id, data) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/resolve" + Session.getToken();
    return instance.post(url, data);
  },
  reabrirRechazo(id) {
    var url = ConfigAPI.baseURL + "finances-cheques-rejections/" + id + "/reopen" + Session.getToken();
    return instance.post(url, null);
  },
  historialCheque(id) {
    var url = ConfigAPI.baseURL + "finances-cheques/" + id + "/history" + Session.getToken();
    return instance.get(url);
  },
  resumenCheques() {
    var url = ConfigAPI.baseURL + "finances-cheques/summary/query" + Session.getToken();
    return instance.post(url, null);
  },
  depositarCheques(data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques-deposits" + Session.getToken();
    return instance.post(url,params);
  },
  mostrarDeposito(id) {
    var url = ConfigAPI.baseURL + "finances-cheques-deposits/" + id + Session.getToken();
    return instance.get(url);
  },
  filtrarDepositos(data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques-deposits/filter/query" + Session.getToken();
    return instance.post(url,params);
  },
  acreditarDeposito(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques-deposits/" + id + "/credit" + Session.getToken();
    return instance.post(url,params);
  },
  revertirDeposito(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques-deposits/" + id + "/revert" + Session.getToken();
    return instance.post(url,params);
  },
  anularChequeDeposito(itemId, data) {
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques-deposits/item/" + itemId + "/cancel" + Session.getToken();
    return instance.post(url,params);
  },

  mostrarStaff(id) {
    var url = ConfigAPI.baseURL + "staff/" + id + Session.getToken();
    return instance.get(url);
  },     
}

export default servicesAPI;